import * as preact from 'preact'
const { h, Component } = preact
import styles from './App.css'
import { connect } from '../../lib/provider'
import { Props as gDocProps } from './types'
import { Section } from './section'
import { Source } from './source'
import { Logo } from './logo'
import PureComponent from '../lib/preact-pure-component'
import { isIOSSafari } from '../lib/isIOSSafari'
interface Props {
  sendGaEvent: (evt: Object) => void
}

interface State {
  activeElement?: string
  activeIdx?: number
  intersectionElements: any[]
  activeSource?: string
  activeSourceButtonID?: string
}

class _App extends PureComponent<Props & gDocProps, State> {
  private wrapper?: Element
  private intersectionObserver?: IntersectionObserver

  constructor() {
    super()
    this.state = {
      activeElement: 'tittelkort-bilde',
      activeIdx: 0,
      intersectionElements: [],
      activeSourceButtonID: undefined
    }
  }

  componentDidMount() {
    let rootMargin = isIOSSafari() ? '0px 0px 75px 0px' : '0px'
    var options = {
      root: null,
      rootMargin,
      threshold: [0]
    }
    this.intersectionObserver = new IntersectionObserver(this.handleIntersect, options)
    this.state.intersectionElements.forEach(el => {
      if (this.intersectionObserver) {
        this.intersectionObserver.observe(el)
      }
    })
  }

  componentWillUnmount() {
    this.intersectionObserver ? this.intersectionObserver.disconnect() : null
  }

  addIntersectionElement = (el: HTMLElement) => {
    this.setState({ intersectionElements: [el, ...this.state.intersectionElements] })
  }

  handleBgChange = (entry: IntersectionObserverEntry) => {
    if (entry.isIntersecting) {
      const id = entry.target.id
      const backgroundId = id.substring(0, id.lastIndexOf('-'))
      const idxOfActiveElement = this.getIdxOfActiveElement(backgroundId)
      this.setState({ activeElement: backgroundId, activeIdx: idxOfActiveElement })
    }
  }

  handleSourceButtonActive = (entry: IntersectionObserverEntry) => {
    if (entry.isIntersecting) {
      const id = entry.target.id.substring(0, entry.target.id.indexOf('-'))
      this.setState({ activeSourceButtonID: id })
    } else {
      this.setState({ activeSourceButtonID: undefined })
    }
  }

  handleIntersect = (entries: IntersectionObserverEntry[]) => {
    entries.forEach(entry => {
      if (entry.target.id.indexOf('-tail') > 0) {
        this.handleSourceButtonActive(entry)
      } else {
        this.handleBgChange(entry)
      }
    })
  }

  setActiveSource = (activeSource?: string) => {
    this.setState({ activeSource })
  }

  getIdxOfActiveElement = (id: string) => {
    if (this.props.doc && this.props.doc.sections) {
      return this.props.doc.sections.findIndex(el => el.id === id)
    }
    return undefined
  }

  shouldPreload = (idx: number) => {
    const { activeIdx } = this.state
    if (activeIdx !== undefined && activeIdx >= 0) {
      if (activeIdx == 0 && idx < 2) {
        return true
      }
      return idx <= activeIdx + 2 && idx >= activeIdx - 2
    }
    return false
  }

  getActiveSection = () => {
    return this.props.doc && this.props.doc.sections && this.state.activeIdx
      ? this.props.doc.sections[this.state.activeIdx]
      : undefined
  }

  render() {
    const sections =
      this.props.doc && this.props.doc.sections
        ? this.props.doc.sections.map((section, idx) => {
            const active = this.state.activeElement === section.id
            const preload = this.shouldPreload(idx)
            const fadeUpDelay =
              this.props.doc &&
              this.props.doc.sections &&
              this.props.doc.sections[idx - 1] &&
              this.props.doc.sections[idx - 1].props &&
              !!this.props.doc.sections[idx - 1].props.fadeOutTo
            return (
              <Section
                preload={preload}
                key={section.id}
                addIntersectionElement={this.addIntersectionElement}
                active={active}
                section={section}
                backgroundFadeUpDelay={fadeUpDelay}
              />
            )
          })
        : undefined

    return (
      <div>
        <Logo />
        <main>
          <div ref={el => (this.wrapper = el)} className={styles.app}>
            {sections}
          </div>
          <Source
            activeSourceButtonID={this.state.activeSourceButtonID}
            activeSection={this.getActiveSection()}
            sources={this.props.doc ? this.props.doc.sources : undefined}
          />
        </main>
      </div>
    )
  }
}

const connector = connect()
export const App = connector(_App)
